"use client";

import { ISpot } from "@/types/spots/spot";

export async function fetchAllBrands(): Promise<string[]> {
  const response = await fetch(`/api/garage-items`);
  if (!response.ok) {
    throw new Error(`Erreur lors de la récupération des marques: ${response.statusText}`);
  }

  const data: ISpot[] = await response.json();
  const uniqueBrands = [...new Set(data.map((item) => item.brand_name).filter(Boolean))];
  return uniqueBrands;
}
